import { render, staticRenderFns } from "./ProjectPlanningResources.vue?vue&type=template&id=cdbf9f06"
import script from "./ProjectPlanningResources.vue?vue&type=script&lang=js"
export * from "./ProjectPlanningResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports